<template>
    <form method="post"
          id="form-not-found-premises"
          action="#"
          @submit.prevent="onSubmit"
          @keydown="form.errors.clear($event.target.name)">

        <div class="form-group row d-flex relative">
            <div class="name-block col-4">
                <label class="name">
                    {{ Lang.get('js.callback_form.your_name') }}<span>*</span>
                </label>
            </div>
            <div class="input col-8">
                <input type="text"
                       name="name"
                       @click="clearFormErrors('name')"
                       class="form-control"
                       v-model="form.name"
                >
                <span class="help is-danger text-danger"
                      v-if="form.errors.has('name')"
                      v-text="Lang.locale == 'ru' ? 'Поле Имя обязательно к заполнению' : 'Поле Ім\'я є обов\'язковим для заповнення'">
            </span>
            </div>
        </div>

        <div class="form-group row d-flex relative">
            <div class="name-block col-4">
                <label class="name">
                    Ваш телефон<span>*</span>
                </label>
            </div>
            <div class="input col-8">
                <input type="text"
                       name="phone"
                       @click="clearFormErrors('phone')"
                       class="form-control mobilephone-input-mask"
                       v-model="form.phone"
                >
                <span class="help is-danger text-danger"
                      v-if="form.errors.has('phone')"
                      v-text="Lang.locale == 'ru' ? 'Поле Телефон имеет ошибочный формат' : 'Поле Телефон має хибний формат'">
            </span>
            </div>
        </div>

        <div class="form-group">
            <textarea name="message"
                      :placeholder="Lang.get('common.notfound')"
                      class="form-control"
                      v-model="form.message">{{ form.message }}</textarea>
            <span class="help is-danger text-danger"
                  v-if="form.errors.has('message')"
                  v-text="form.errors.get('message')">
            </span>
        </div>

        <input class="btn my-btn type-1"
               type="submit"
               :disabled="form.errors.any()"
               :value="Lang.get('common.send')">
        <widget-loading v-if="form.loading" color="#03a9f4"></widget-loading>
        <p class="warning-msg">{{Lang.get('common.warning-msg')}}</p>
    </form>
</template>

<script>
    import WidgetLoading from '../elements/WidgetLoading';

    export default {
        name: "form-not-found-premises",
        components: {
            WidgetLoading,
        },
        data() {
            return {
                form: new Form({
                    name: '',
                    phone: '',
                    message: '',
                    type: 'not-found',
                    url: location,
                    // lang: siteLang,
                }),
                action: '/callback',
                Lang,
            }
        },
        methods: {
            clearFormErrors(name) {
                this.form.errors.clear(name);
                if (!this.form.errors.any()) {
                    this.isDisabled = false;
                }
            },
            onSubmit() {

                let lang_post = this.Lang.locale != 'ua' ? `${this.Lang.locale}/callback` : '/callback';

                this.form.submit(this.$el.method, lang_post).then(res => {
                    document.querySelector('#form-not-found-premises').innerHTML = res;
                }).catch(error => console.log(error));
            },
        },
        mounted() {
            helpers.setInputMask('mobilephone');
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/forms/FormNotFoundPremises.vue